import React, { Dispatch, SetStateAction } from "react";
import { LinkedAccount } from "../../../../../models/Entities";
import SyncHistoryView from "./SyncHistoryView";
import { Text } from "@merge-api/merge-javascript-shared";

export interface Props {
  /**
   * The account we have linked or nothing if we have only an id
   */
  linkedAccount: LinkedAccount | null;
  linkedAccounts: LinkedAccount[] | null;
  setLinkedAccount: Dispatch<SetStateAction<LinkedAccount | null>>;
}

const SyncOverview = ({ linkedAccount, linkedAccounts, setLinkedAccount }: Props) => {
  return (
    <div className="w-full flex flex-col">
      <Text variant="h4" className="mt-11 mb-7">
        Sync overview
      </Text>
      <SyncHistoryView
        linkedAccount={linkedAccount}
        linkedAccounts={linkedAccounts}
        setLinkedAccount={setLinkedAccount}
      />
    </div>
  );
};

export default SyncOverview;
